import { defineStore } from 'pinia';
import ClientTabs from '@/system/components/client/ClientTabs';

export const useClientMainTabsStore = defineStore('clientMainTabs', {
    state: () => ({
        /**
         * Current active tab ID in the main area (from ClientTabs constants)
         */
        activeTab: null,
    }),

    getters: {
        isJournalTabActive: (state) => state.activeTab === ClientTabs.Journals,
        isMedcomTabActive: (state) => state.activeTab === ClientTabs.MedcomDocuments,
        isAppointmentsTabActive: (state) => state.activeTab === ClientTabs.Appointments,
        isDocumentsTabActive: (state) => state.activeTab === ClientTabs.Documents,
        isMessagingTabActive: (state) => state.activeTab === ClientTabs.Messages,
        isHelsenettTabActive: (state) => state.activeTab === ClientTabs.MessagingService,
    },

    actions: {
        setActiveTab(tabId) {
            this.activeTab = tabId;
        },
        
        clearActiveTab() {
            this.activeTab = null;
        }
    }
});
